<section class="listing-manage" role="img" aria-label="Increased revenue and explosive profits">
  <div class="container">
    <div class="d-flex align-items-center row fixed-height">
      <div class="col-xl-6 order-2 order-xl-1 mt-4 mt-xl-0">
        <img class="img-fluid" src="https://company.rubbl.com/pubweb/marketplace/images/landing-pages/list-your-machines/owner-details-pages.png" />
      </div>
      <div class="col-xl-5 order-1 order-xl-2 mobile-margin">
        <div>
          <h2 class="marketing">Always in control</h2>
          <p class="subhead-2 text-grey">
            Your fleet dashboard gives you visibility into every aspect of your rented gear, while putting all of the control in your hands.
          </p>
          <a [routerLink]="['/signup']" [queryParams]="{ capability: 'owner' }" [skipLocationChange]="true">Get Started</a>
        </div>

        <div class="row mt-5">
          <div class="col-md-4 col-xl-4" [attr.data-aos-delay]="250 * (i + 1)" *ngFor="let marketingCard of marketingCards; index as i">
            <common-marketing-card [marketingCard]="marketingCard"></common-marketing-card>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
